"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortFieldBy = exports.sortByIPv4 = exports.sortByVersion = exports.sortByDuration = exports.sortByDate = exports.sortByString = exports.sortByNumber = exports.sortByBoolean = exports.sortByPropertyNull = exports.sortByPropertyNil = exports.sortByPropertyExistance = exports.ipToCombinedInt = void 0;
var moment_1 = __importDefault(require("moment"));
var isNullish = function (x) { return x === null || typeof x === 'undefined'; };
/** @deprecated Will be removed in a future major version */
var ipToCombinedInt = function (ip) {
    return parseInt((ip + '')
        .split('.')
        .reduce(function (combinedStr, octet) { return combinedStr + octet.padStart(3, '0'); }, ''));
};
exports.ipToCombinedInt = ipToCombinedInt;
/** Numeric representation of the result of 2 values being compared `cmp(a, b)` where `a < b` */
var LessThan = -1;
/** Numeric representation of the result of 2 values being compared `cmp(a, b)` where `a > b` */
var GreaterThan = 1;
/** Numeric representation of the result of 2 values being compared `cmp(a, b)` where `a = b` */
var EqualTo = 0;
var sortByPropertyExistance = function (property, a, b) {
    if (typeof a[property] !== 'undefined' &&
        typeof b[property] === 'undefined') {
        return GreaterThan;
    }
    if (typeof b[property] !== 'undefined' &&
        typeof a[property] === 'undefined') {
        return LessThan;
    }
    return EqualTo;
};
exports.sortByPropertyExistance = sortByPropertyExistance;
/** @deprecated Will be removed in a future major version */
var sortByPropertyNil = function (property, a, b) {
    if (!isNullish(a[property]) && isNullish(b[property])) {
        return GreaterThan;
    }
    if (!isNullish(b[property]) && isNullish(a[property])) {
        return LessThan;
    }
    return EqualTo;
};
exports.sortByPropertyNil = sortByPropertyNil;
/** @deprecated Will be removed in a future major version */
var sortByPropertyNull = function (property, a, b) {
    if (a[property] !== null && b[property] === null) {
        return GreaterThan;
    }
    if (b[property] !== null && a[property] === null) {
        return LessThan;
    }
    return EqualTo;
};
exports.sortByPropertyNull = sortByPropertyNull;
/**
 * If equal -> 0 else if a is true it must be greater than b
 * @deprecated Will be removed in a future major version
 */
var sortByBoolean = function (a, b) { return (!!a === !!b ? EqualTo : a ? GreaterThan : LessThan); };
exports.sortByBoolean = sortByBoolean;
/** @deprecated Will be removed in a future major version */
var sortByNumber = function (a, b) { return (a === b ? EqualTo : a > b ? GreaterThan : LessThan); };
exports.sortByNumber = sortByNumber;
var sortByString = function (a, b) {
    if (isNullish(a)) {
        return isNullish(b) ? EqualTo : LessThan;
    }
    if (isNullish(b)) {
        return GreaterThan;
    }
    return a.localeCompare(b);
};
exports.sortByString = sortByString;
/** @deprecated Will be removed in a future major version */
var sortByDate = function (a, b) {
    if (isNullish(a)) {
        return isNullish(b) ? EqualTo : LessThan;
    }
    if (isNullish(b)) {
        return GreaterThan;
    }
    var aMoment = (0, moment_1.default)(a);
    var bMoment = (0, moment_1.default)(b);
    return aMoment.isSame(bMoment) ? EqualTo : aMoment.isAfter(bMoment) ? GreaterThan : LessThan;
};
exports.sortByDate = sortByDate;
/** @deprecated Will be removed in a future major version */
var sortByDuration = function (a, b) {
    if (isNullish(a)) {
        return isNullish(b) ? EqualTo : LessThan;
    }
    if (isNullish(b)) {
        return GreaterThan;
    }
    return (0, exports.sortByNumber)(a.asMilliseconds(), b.asMilliseconds());
};
exports.sortByDuration = sortByDuration;
/** @deprecated Will be removed in a future major version */
var sortByVersion = function (a, b) {
    if (isNullish(a)) {
        return isNullish(b) ? EqualTo : LessThan;
    }
    if (isNullish(b)) {
        return GreaterThan;
    }
    // Split by dots so that we can compare each version 'digit' to find out which one is bigger
    var aSplitVersion = a.split('.').map(function (digit) { return parseInt(digit); });
    var bSplitVersion = b.split('.').map(function (digit) { return parseInt(digit); });
    // While there are still digits to compare
    for (var i = 0; typeof aSplitVersion[i] !== 'undefined' ||
        typeof bSplitVersion[i] !== 'undefined'; i++) {
        var aDigit = aSplitVersion[i];
        var bDigit = bSplitVersion[i];
        // EXCEPTION for handling 16.X and 17.X clients which are from our old versioning system when we used to version clients by year (2016, 2017)
        // Check to see if we still need this before porting this code
        if (i === 0) {
            if (aDigit === 16 || aDigit === 17) {
                aDigit -= 10;
            }
            else if (aDigit === 2016 || aDigit === 2017) {
                aDigit -= 2010;
            }
            if (bDigit === 16 || bDigit === 17) {
                bDigit -= 10;
            }
            else if (bDigit === 2016 || bDigit === 2017) {
                bDigit -= 2010;
            }
        }
        // a version has ended, only look at b, if it has a non-zero digit, it is bigger
        if (typeof aDigit === 'undefined' && bDigit > 0) {
            return LessThan;
            // b version has ended, only look at a, if it has a non-zero digit it is bigger
        }
        else if (typeof bDigit === 'undefined' && aDigit > 0) {
            return GreaterThan;
            // Both digits exist
        }
        else if (aDigit > bDigit) {
            return GreaterThan;
        }
        else if (bDigit > aDigit) {
            return LessThan;
        }
    }
    // If we haven't determined whether one is bigger than the other by this point, they are equal
    return EqualTo;
};
exports.sortByVersion = sortByVersion;
/** @deprecated Will be removed in a future major version */
var sortByIPv4 = function (a, b) {
    if (isNullish(a)) {
        return isNullish(b) ? EqualTo : LessThan;
    }
    if (isNullish(b)) {
        return GreaterThan;
    }
    return (0, exports.sortByNumber)((0, exports.ipToCombinedInt)(a), (0, exports.ipToCombinedInt)(b));
};
exports.sortByIPv4 = sortByIPv4;
var sortFieldBy = function (fieldName, sortFn) {
    return function (a, b) {
        if (!a || !b) {
            return (0, exports.sortByPropertyExistance)('field', { field: a }, { field: b });
        }
        return sortFn(a[fieldName], b[fieldName]);
    };
};
exports.sortFieldBy = sortFieldBy;
exports.default = {
    sortByPropertyExistance: exports.sortByPropertyExistance,
    sortByPropertyNil: exports.sortByPropertyNil,
    sortByPropertyNull: exports.sortByPropertyNull,
    sortByBoolean: exports.sortByBoolean,
    sortByNumber: exports.sortByNumber,
    sortByString: exports.sortByString,
    sortByDate: exports.sortByDate,
    sortByDuration: exports.sortByDuration,
    sortByVersion: exports.sortByVersion,
    // Assumed to be valid
    sortByIPv4: exports.sortByIPv4,
    // Applies sort function to a field on an object
    sortFieldBy: exports.sortFieldBy,
};
//# sourceMappingURL=sort.js.map